import { Record } from 'immutable';

export const PlanAccessRecord = Record({
  name: { value: '', obs: '' },
  basic: { value: false, obs: '' },
  premium: { value: false, obs: '' },
});
